import v1 from './v1'
import v2 from './v2'

/**
 * API Super Class
 */
class API {
  constructor(session) {
    this.v1 = new v1(session)
    this.v2 = new v2(session)
  }
}

export default API
